import React from 'react'
import InsightTab from '../tab'
import { Col, Row } from 'react-bootstrap'
import InsightHero from '../hero-section'
import ResultHero from '../result-hero-section'
import './wrapper.scss';
import { SectionWrapper } from '../../../../theme/layouts/MainLayout'
import { altLtGray, techBlack } from '../../../../common/utils/constant';

function InsightWrapper(props) {
  const {base_url,items} = props;

  return (
    <div className='insight-wrapper'>
      <SectionWrapper bg={techBlack}>
       
        <section>
        <Row>
          <Col>
            <InsightHero title={props.heroText} />
          </Col>
        </Row>
        </section>
      </SectionWrapper>
      <SectionWrapper bg={altLtGray}>
       
        <section>
        <InsightTab />
        </section>
      </SectionWrapper>
      <SectionWrapper bg={altLtGray}>
       
        <section>
        {items && <ResultHero data={items} base_url={base_url}/>}
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
       
        <section className='insight-container'>
        {props.children}
        </section>
      </SectionWrapper>
    </div>
  )
}

export default InsightWrapper